/**
 * @fileoverview Product Carousel Implementation
 * @description Implements a responsive product carousel with dynamic slide positioning and mouse-follow effects
 *
 * Dependencies:
 * - jQuery
 * - Swiper.js
 *
 * HTML Structure Required:
 * - Element with class "product-carousel-section" containing:
 *   * Element with class "product-carousel__wrapper" with data attribute:
 *     - data-count: Number of products to show (used for responsive breakpoints)
 *   * Element with class "swiper-carousel" for the main carousel
 *   * Elements with class "swiper-slide" for individual slides
 *   * Navigation elements with classes "swiper-button-next__prod" and "swiper-button-prev__prod"
 *   * Optional: Element with class "button--with-underline--container" for mouse-follow effect
 */

(function () {
  /**
   * @function prodcarousel
   * @description Initializes and configures the product carousel with multiple instances support
   */
  let prodcarousel = () => {
    $('.product-carousel-section').each(function () {
      let slideEl = $(this).find('.product-carousel__wrapper');
      let carousel = $(this).find('.swiper-carousel');
      let slide = $(this).find('.swiper-slide');
      let buttonNext = $(this).find('.swiper-button-next');
      let prodCountHalf = parseFloat(slideEl.data('count')) + 0.1;
      if ($(this).hasClass('slider_started')) {
        return '';
      }

      $(this).addClass('slider_started');
      let id = $(this).attr('id');

      /**
       * @type {Object} Base Swiper configuration parameters
       */
      let prodSwiperParams = {
        centeredSlides: false,
        slidesPerView: 1.1,
        waitForTransition: false,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        preloadImages: true,
        allowTouchMove: true,
        spaceBetween: 4,
        breakpoints: {
          990: {
            slidesPerView: 2.1,
          },
          1200: {
            slidesPerView: 3.1,
          },
          1360: {
            slidesPerView: prodCountHalf,
          },
        },
        on: {
          /**
           * @function slideChange
           * @description Handles slide change events and updates positioning classes
           */
          slideChange: function () {
            if (this.activeIndex === 0) {
              // Reset all slides to initial position
              Array.from(slide).forEach((element) => {
                element.classList.remove('slide_change-postion');
              });
              Array.from(carousel).forEach((element) => {
                element.classList.add('carousel_change-postion_next');
                element.classList.remove('carousel_change-postion_prev');
                element.classList.remove('carousel_change-postion_next-2');
              });
              this.update();
            } else {
              if (this.activeIndex > this.previousIndex) {
                // Handle forward navigation
                Array.from(carousel).forEach((element) => {
                  element.classList.remove('carousel_change-postion_next');
                  element.classList.remove('carousel_change-postion_next-2');
                  element.classList.add('carousel_change-postion_prev');
                });
                Array.from(slide).forEach((element) => {
                  if (buttonNext.hasClass('swiper-button-disabled')) {
                    element.classList.remove('slide_change-postion');
                  } else {
                    element.classList.add('slide_change-postion');
                  }
                });
              } else {
                // Handle backward navigation
                Array.from(carousel).forEach((element) => {
                  element.classList.add('carousel_change-postion_next-2');
                  element.classList.remove('carousel_change-postion_prev');
                });
                Array.from(slide).forEach((element) => {
                  element.classList.remove('slide_change-postion');
                });
              }
              this.update();
            }
          },
        },
      };

      // Initialize Swiper instance
      let swiperSlider = new Swiper(`#${id} .swiper-carousel`, {
        navigation: {
          nextEl: `#${id} .swiper-button-next__prod`,
          prevEl: `#${id} .swiper-button-prev__prod`,
        },
        ...prodSwiperParams,
      });
    });
  };

  // Initialize on various events
  document.addEventListener('DOMContentLoaded', function () {
    prodcarousel();
  });

  document.addEventListener('shopify:section:load', function () {
    prodcarousel();
  });

  document.addEventListener('resize', function () {
    prodcarousel();
  });

  document.addEventListener('visibilitychange', function () {
    prodcarousel();
  });

  prodcarousel();

  /**
   * Mouse-follow effect implementation for desktop
   */
  if (window.screen.width > 990) {
    let attachedProductCarousel = false;
    let carouselSection = document.querySelector('.product-carousel-section');
    let imageContainerCarousel = carouselSection?.querySelector(
      '.button--with-underline--container'
    );

    /**
     * @function followMouseCarousel
     * @description Updates the position of the underline container to follow the mouse
     * @param {MouseEvent} event - The mouse event containing position information
     */
    let followMouseCarousel = (event) => {
      if (imageContainerCarousel) {
        imageContainerCarousel.style.left = event.pageX + 'px';
        imageContainerCarousel.style.top = event.pageY + 30 + 'px';
      }
    };

    /**
     * @function showTextCarousel
     * @description Shows the mouse-follow effect and attaches the event listener
     */
    function showTextCarousel() {
      if (!attachedProductCarousel && imageContainerCarousel) {
        attachedProductCarousel = true;
        imageContainerCarousel.style.display = 'block';
        document.addEventListener('pointermove', followMouseCarousel);
      }
    }

    /**
     * @function hideTextCarousel
     * @description Hides the mouse-follow effect and removes the event listener
     */
    function hideTextCarousel() {
      if (imageContainerCarousel) {
        attachedProductCarousel = false;
        imageContainerCarousel.style.display = '';
        document.removeEventListener('pointermove', followMouseCarousel);
      }
    }
  }
})();
